/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/resetTwoFactor.scss';

import {ChangeFunction, Checkbox} from '@dvrd/dvr-controls';
import React, {MouseEventHandler} from 'react';
import {BolmateButton} from "../../controls";
import Image from "../../misc/image";

interface Props {
    onChangeConfirmed: ChangeFunction<boolean>;
    onSubmit: MouseEventHandler;
    confirmed: boolean;
    loading: boolean;
}

export default function ResetTwoFactor(props: Props) {
    const {confirmed, onChangeConfirmed, onSubmit, loading} = props;

    return (
        <div className='reset-two-factor'>
            <div className='logo-header'>
                <Image name='logo' className='logo'/>
                {/*<img className='logo' src={getImg('logo')} alt='Bolmate'/>*/}
            </div>
            <div className='reset-content'>
                <h2 className='title'>Tweestapsverificatie uitschakelen</h2>
                <p className='warning'>Je staat op het punt om de tweestapsverificatie van jouw account uit te
                    schakelen. De tweestapsverificatie voegt een extra laag beveiliging toe aan jouw account, we raden
                    aan deze dus alleen uit te schakelen wanneer je geen toegang meer hebt tot jouw account.</p>
                <Checkbox checked={confirmed} onCheck={onChangeConfirmed}
                          label='Ik bevestig dat tweestapsverificatie uitgeschakeld moet worden'/>
                <BolmateButton onClick={onSubmit} label='Tweestapsverificatie uitschakelen'
                               disabled={!confirmed || loading}/>
            </div>
        </div>
    )
}